import { render, staticRenderFns } from "./ContentsChange.vue?vue&type=template&id=da4bb51a&"
import script from "./ContentsChange.vue?vue&type=script&lang=js&"
export * from "./ContentsChange.vue?vue&type=script&lang=js&"
import style0 from "./ContentsChange.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports